<template>
  <v-snackbar v-model="showUpdatePrompt" top :timeout="0" multi-line>
    <span v-if="!updating">Mise à jour disponible !</span>
    <span v-if="updating">Mise à jour en cours</span>
    <v-btn class="ml-0" text v-if="!updating" @click="forceRefresh">Update</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: "UpdatePrompt",
  data: () => ({
    showUpdatePrompt: false,
    updating: false
  }),
  methods: {

    // Force refresh app
    forceRefresh() {
      // Add event listeners
      this.$emit('logout')
      this.updating = true

      setTimeout(function () {
        location.reload(true)
      }, 500)
    }
  },
  mounted() {
    let root = this;

    setInterval(function () {
      if (window.updateReady === true) {
        root.showUpdatePrompt = true;
      } else {
        root.showUpdatePrompt = false;
      }
    }, 1000)
  }
};
</script>

<style>
</style>
